import Color from 'color'
import themeObj from 'styles/cantileverTheme'

// Color constants
const SENSOR_COLORS = [
  themeObj.colors.LimeGreen,
  themeObj.colors.BrightOrange,
  themeObj.colors.Turquoise,
  themeObj.colors.Vermilion,
  themeObj.colors.SeaGreen,
  themeObj.colors.LemonYellow,
  themeObj.colors.OceanBlue,
  themeObj.colors.Tangerine,
  themeObj.colors.MintGreen,
  themeObj.colors.SkyBlue,
  themeObj.colors.Teal,
  themeObj.colors.LightSkyBlue,
]

// Pre-compute sensor colors as hex values
export const SENSOR_COLORS_HEX = SENSOR_COLORS.map((color) =>
  Color(color).hex()
)

export const getSensorColor = (sensorIndex: number) => {
  return SENSOR_COLORS_HEX[sensorIndex % SENSOR_COLORS_HEX.length]
}
